const setRem = (designWidth, rem2px) => {
  if (document && document.documentElement) {
    document.documentElement.style.fontSize = '500%';
    const d = window.document.createElement('div');
    d.style.width = '1rem';
    d.style.display = 'none';
    const head = window.document.getElementsByTagName('head')[0];
    head.appendChild(d);
    const defaultFontSize =
      parseFloat(window.getComputedStyle(d, null).getPropertyValue('width')) / 5;
    head.removeChild(d);
    console.log(document.body.offsetWidth);
    if (document.body.offsetWidth > 1000) {
      document.documentElement.style.fontSize = `14px`;
    } else {
      document.documentElement.style.fontSize = `${
        (((document.documentElement.clientWidth / designWidth) * rem2px) / defaultFontSize) * 100
      }%`;
    }
  }
};

const remInit = (designWidth, rem2px) => {
  const flexible = setRem.bind(null, designWidth, rem2px);
  flexible();
  window.addEventListener('DOMContentLoaded', flexible);
  window.addEventListener('resize', flexible);
  window.addEventListener('pageshow', (e) => e.persisted && flexible());
};

export default remInit;
